
export default class DescuentoDetalleBuilder {
  static build() {
     return {
      bonificacionVariable: {
        precioAlza: null,
        cantidad: null,
        tipo: 'importe',
        id: null,
      },
      bonificacionesEstaticas: [],
    };
  }
}
